"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CurrencyFormat = _interopRequireDefault(require("../../CurrencyFormat"));
var _symbols = require("../../../constants/symbols");
var _userflow = _interopRequireDefault(require("../../../styles/userflow"));
var _utils = require("../utils");
var PriceMatrixCell = function PriceMatrixCell(props) {
  var full_price = props.full_price,
    link = props.link,
    duration = props.duration,
    price_coefficient = props.price_coefficient,
    isMobile = props.isMobile,
    target = props.target,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  var _getCellStyle = (0, _utils.getCellStyle)(price_coefficient),
    styles = _getCellStyle.styles;
  var isTarget = duration === String(target === null || target === void 0 ? void 0 : target.nights);
  var price = isTarget ? ' Нет туров' : /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: full_price
  });
  return /*#__PURE__*/_react["default"].createElement(Cell, {
    href: link,
    className: className,
    bgColor: styles.container.backgroundColor,
    withoutPrice: !full_price,
    isMobile: isMobile,
    isTarget: isTarget
  }, full_price ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Nights, {
    isTarget: isTarget
  }, duration, _symbols.MOON), price) : 'Нет данных');
};
var Cell = _styledComponents["default"].a.withConfig({
  displayName: "PriceMatrixCell__Cell",
  componentId: "sc-1wmpxrr-0"
})(["display:flex;flex-direction:column;width:", "px;height:", "px;align-items:center;justify-content:center;text-decoration:none;font-size:10px;background-color:", ";color:", ";margin-top:1px;margin-left:1px;", " ", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 72 : 58;
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 40 : 42;
}, function (_ref3) {
  var bgColor = _ref3.bgColor;
  return bgColor;
}, _userflow["default"].colors.blackBase, function (_ref4) {
  var withoutPrice = _ref4.withoutPrice;
  return withoutPrice && "\n    background-color: transparent;\n    color: #C2C5CC;\n    pointer-events: none;\n  ";
}, function (_ref5) {
  var isTarget = _ref5.isTarget;
  return isTarget && "\n    background: rgba(248, 231, 28, .4);\n    font-weight: 500;\n  ";
});
var Nights = _styledComponents["default"].div.withConfig({
  displayName: "PriceMatrixCell__Nights",
  componentId: "sc-1wmpxrr-1"
})(["color:", ";", ""], _userflow["default"].colors.greyLight, function (_ref6) {
  var isTarget = _ref6.isTarget;
  return isTarget && "\n    color: unset;\n  ";
});
var _default = exports["default"] = PriceMatrixCell;